const excludeNested = (categories) => {
  if (!categories.all) return [];

  const resultsIdsToDisplayUpToLevelTwo =
    categories.resultsToDisplay
    .filter(res => res.level < 2)
    .map(res => res.id);

  return categories.all
    .filter(category =>
    {
     return resultsIdsToDisplayUpToLevelTwo.includes(category.id)
    });
};

export default excludeNested;



// WEBPACK FOOTER //
// ./src/helpers/unileverSales/excludeNested.js